import { render, staticRenderFns } from "./PretrainedModels.vue?vue&type=template&id=38e5c759"
import script from "./PretrainedModels.vue?vue&type=script&lang=js"
export * from "./PretrainedModels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports